import {Component} from '@angular/core';
import {PcCallDialComponent} from "../../pc-call-dial/pc-call-dial.component";
import {CoChannelAccessTypeEnum} from "../../../../../../feature-core/co/enum/co-channel-access-type-enum.enum";

/**
 * The consultant portal's phone dial - the same component as the internal one, with its own template.
 *
 * <h3>TM-1000002005 - the restriction check is NOT overridden here any more</h3>
 * This class used to carry its own copy of {@code confirmStartCall} and {@code getCallAccessIcons},
 * because the base class asked unconditionally and this variant wanted the gated question. Both are
 * now one call into {@code CoChannelContactGuardService} in the base class, and that service is also
 * where the customer level Kommunikationssperre is checked - so a copy here would be one more site
 * that has to be remembered the next time the condition changes, and would be forgotten.
 *
 * What remains is the template difference and {@link CoChannelAccessTypeEnum}, which the consultant
 * template compares against directly.
 */
@Component({
    selector: 'mvs-pc-call-dial-consultant',
    templateUrl: './pc-call-dial-consultant.component.html',
    standalone: false,
})
export class PcCallDialConsultantComponent extends PcCallDialComponent {

    ngOnInit(): void {
        super.ngOnInit();
    }

    protected getCallAccessIcons(access: CoChannelAccessTypeEnum): string {
        return this.coUiService.getChannelAccessIcon(access);
    }

    protected readonly CoChannelAccessTypeEnum = CoChannelAccessTypeEnum;
}
